export const Malaga_Device_Points_Config = {
  CB_G1_DATA_POINTS: [
    {
      label: '52A Status',
      pointName: 'sub_m1_52m1_gp1_700g_52a_status',
    },
    {
      label: 'HZ',
      pointName: 'sub_m1_52m1_gp1_700g_hz',
    },
    {
      label: 'VOLTAGE',
      pointName: 'sub_m1_52m1_gp1_700g_vab',
    },
    {
      label: 'CURRENT',
      pointName: 'sub_m1_52m1_gp1_700g_ia',
    },
    {
      label: 'KW',
      pointName: 'sub_m1_52m1_gp1_700g_kw',
    },
    {
      label: 'KVAR',
      pointName: 'sub_m1_52m1_gp1_700g_kvar',
    },
  ],
  CB_G2_DATA_POINTS: [
    {
      label: '52A Status',
      pointName: 'sub_m2_52m2_gp2_700g_52a_status',
    },
    {
      label: 'HZ',
      pointName: 'sub_m2_52m2_gp2_700g_hz',
    },
    {
      label: 'VOLTAGE',
      pointName: 'sub_m2_52m2_gp2_700g_vab',
    },
    {
      label: 'CURRENT',
      pointName: 'sub_m2_52m2_gp2_700g_ia',
    },
    {
      label: 'KW',
      pointName: 'sub_m2_52m2_gp2_700g_kw',
    },
    {
      label: 'KVAR',
      pointName: 'sub_m2_52m2_gp2_700g_kvar',
    },
  ],
  A1_DATA_POINTS: [
    {
      label: '52A Status',
      pointName: 'sub_a1_52fa1_751_52a_status',
    },
    {
      label: 'HZ',
      pointName: 'sub_a1_52fa1_751_hz',
    },
    {
      label: 'KV',
      pointName: 'sub_a1_52fa1_751_kv',
    },
    {
      label: 'VOLTAGE',
      pointName: 'sub_a1_52fa1_751_vab',
    },
    {
      label: 'CURRENT',
      pointName: 'sub_a1_52fa1_751_ia',
    },
    {
      label: 'KW',
      pointName: 'sub_a1_52fa1_751_kw',
    },
    {
      label: 'KVAR',
      pointName: 'sub_a1_52fa1_751_kvar',
    },
  ],
  A2_DATA_POINTS: [
    {
      label: '52A Status',
      pointName: 'sub_a2_52fa2_751_52a_status',
    },
    {
      label: 'HZ',
      pointName: 'sub_a2_52fa2_751_hz',
    },
    {
      label: 'KV',
      pointName: 'sub_a2_52fa2_751_kv',
    },
    {
      label: 'VOLTAGE',
      pointName: 'sub_a2_52fa2_751_vab',
    },
    {
      label: 'CURRENT',
      pointName: 'sub_a2_52fa2_751_ia',
    },
    {
      label: 'KW',
      pointName: 'sub_a2_52fa2_751_kw',
    },
    {
      label: 'KVAR',
      pointName: 'sub_a2_52fa2_751_kvar',
    },
  ],
  F1_1_DATA_POINTS: [
    {
      label: '52A Status',
      pointName: 'sub_f1_52f1_1_751_52a_status',
    },
    {
      label: 'HZ',
      pointName: 'sub_f1_52f1_1_751_hz',
    },
    {
      label: 'VOLTAGE',
      pointName: 'sub_f1_52f1_1_751_vab',
    },
    {
      label: 'CURRENT',
      pointName: 'sub_f1_52f1_1_751_ia',
    },
    {
      label: 'KW',
      pointName: 'sub_f1_52f1_1_751_kw',
    },
    {
      label: 'KVAR',
      pointName: 'sub_f1_52f1_1_751_kvar',
    },
  ],
  F1_2_DATA_POINTS: [
    {
      label: '52A Status',
      pointName: 'sub_f1_52f1_2_751_52a_status',
    },
    {
      label: 'HZ',
      pointName: 'sub_f1_52f1_2_751_hz',
    },
    {
      label: 'VOLTAGE',
      pointName: 'sub_f1_52f1_2_751_vab',
    },
    {
      label: 'CURRENT',
      pointName: 'sub_f1_52f1_2_751_ia',
    },
    {
      label: 'KW',
      pointName: 'sub_f1_52f1_2_751_kw',
    },
    {
      label: 'KVAR',
      pointName: 'sub_f1_52f1_2_751_kvar',
    },
  ],
  F1_3_DATA_POINTS: [
    {
      label: '52A Status',
      pointName: 'sub_f1_52f1_3_751_52a_status',
    },
    {
      label: 'HZ',
      pointName: 'sub_f1_52f1_3_751_hz',
    },
    {
      label: 'VOLTAGE',
      pointName: 'sub_f1_52f1_3_751_vab',
    },
    {
      label: 'CURRENT',
      pointName: 'sub_f1_52f1_3_751_ia',
    },
    {
      label: 'KW',
      pointName: 'sub_f1_52f1_3_751_kw',
    },
    {
      label: 'KVAR',
      pointName: 'sub_f1_52f1_3_751_kvar',
    },
  ],
  F2_1_DATA_POINTS: [
    {
      label: '52A Status',
      pointName: 'sub_f2_52f2_1_751_52a_status',
    },
    {
      label: 'HZ',
      pointName: 'sub_f2_52f2_1_751_hz',
    },
    {
      label: 'VOLTAGE',
      pointName: 'sub_f2_52f2_1_751_vab',
    },
    {
      label: 'CURRENT',
      pointName: 'sub_f2_52f2_1_751_ia',
    },
    {
      label: 'KW',
      pointName: 'sub_f2_52f2_1_751_kw',
    },
    {
      label: 'KVAR',
      pointName: 'sub_f2_52f2_1_751_kvar',
    },
  ],
  F2_2_DATA_POINTS: [
    {
      label: '52A Status',
      pointName: 'sub_f2_52f2_2_751_52a_status',
    },
    {
      label: 'HZ',
      pointName: 'sub_f2_52f2_2_751_hz',
    },
    {
      label: 'VOLTAGE',
      pointName: 'sub_f2_52f2_2_751_vab',
    },
    {
      label: 'CURRENT',
      pointName: 'sub_f2_52f2_2_751_ia',
    },
    {
      label: 'KW',
      pointName: 'sub_f2_52f2_2_751_kw',
    },
    {
      label: 'KVAR',
      pointName: 'sub_f2_52f2_2_751_kvar',
    },
  ],
  F2_3_DATA_POINTS: [
    {
      label: '52A Status',
      pointName: 'sub_f2_52f2_3_751_52a_status',
    },
    {
      label: 'HZ',
      pointName: 'sub_f2_52f2_3_751_hz',
    },
    {
      label: 'VOLTAGE',
      pointName: 'sub_f2_52f2_3_751_vab',
    },
    {
      label: 'CURRENT',
      pointName: 'sub_f2_52f2_3_751_ia',
    },
    {
      label: 'KW',
      pointName: 'sub_f2_52f2_3_751_kw',
    },
    {
      label: 'KVAR',
      pointName: 'sub_f2_52f2_3_751_kvar',
    },
  ],
};
